module.exports = __webpack_public_path__ + "img/icon-scan-qr-code-02.02353839.svg";